var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNavLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.55 18C14.4515 18.0005 14.3538 17.9812 14.2628 17.9435C14.1718 17.9057 14.0892 17.8501 14.02 17.78L9.02 12.78C8.91709 12.6781 8.83572 12.5565 8.78075 12.4225C8.72577 12.2885 8.69831 12.1448 8.7 12C8.6935 11.7107 8.80128 11.4304 9 11.22L14 6.22C14.1406 6.07955 14.3312 6.00066 14.53 6.00066C14.7288 6.00066 14.9194 6.07955 15.06 6.22C15.1308 6.28895 15.187 6.37136 15.2254 6.46239C15.2638 6.55341 15.2836 6.65121 15.2836 6.75C15.2836 6.84879 15.2638 6.94659 15.2254 7.03761C15.187 7.12864 15.1308 7.21105 15.06 7.28L10.36 12L15.08 16.72C15.1508 16.7889 15.207 16.8714 15.2454 16.9624C15.2838 17.0534 15.3036 17.1512 15.3036 17.25C15.3036 17.3488 15.2838 17.4466 15.2454 17.5376C15.207 17.6286 15.1508 17.7111 15.08 17.78C15.0111 17.8506 14.9286 17.9065 14.8375 17.9443C14.7464 17.9821 14.6486 18.001 14.55 18Z",
    fill: "#0071c2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNavLeft);
export default __webpack_public_path__ + "static/media/ArrowNavLeft.0779ca8e767b9b1199d0199fbb72e4d8.svg";
export { ForwardRef as ReactComponent };